import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-32517bcf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "audio-style-panel" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "图标颜色：", -1))
const _hoisted_4 = { class: "row switch-row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "自动播放：", -1))
const _hoisted_6 = {
  class: "switch-wrapper",
  style: {"width":"60%"}
}
const _hoisted_7 = { class: "row switch-row" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"width":"40%"} }, "循环播放：", -1))
const _hoisted_9 = {
  class: "switch-wrapper",
  style: {"width":"60%"}
}

import type { Ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import type { PPTAudioElement } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import ColorButton from '../common/ColorButton.vue'
import ColorPicker from '@/components/ColorPicker/index.vue'
import Switch from '@/components/Switch.vue'
import Popover from '@/components/Popover.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AudioStylePanel',
  setup(__props) {

const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())

const handleAudioElement = handleElement as Ref<PPTAudioElement>

const { addHistorySnapshot } = useHistorySnapshot()

const updateAudio = (props: Partial<PPTAudioElement>) => {
  if (!handleElement.value) return
  slidesStore.updateElement({ id: handleElement.value.id, props })
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(Popover, {
        trigger: "click",
        style: {"width":"60%"}
      }, {
        content: _withCtx(() => [
          _createVNode(ColorPicker, {
            modelValue: _unref(handleAudioElement).color,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = value => updateAudio({ color: value }))
          }, null, 8, ["modelValue"])
        ]),
        default: _withCtx(() => [
          _createVNode(ColorButton, {
            color: _unref(handleAudioElement).color
          }, null, 8, ["color"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(Switch, {
          value: _unref(handleAudioElement).autoplay,
          "onUpdate:value": _cache[1] || (_cache[1] = value => updateAudio({ autoplay: value }))
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createVNode(Switch, {
          value: _unref(handleAudioElement).loop,
          "onUpdate:value": _cache[2] || (_cache[2] = value => updateAudio({ loop: value }))
        }, null, 8, ["value"])
      ])
    ])
  ]))
}
}

})